/* @flow */
import { createSelector } from 'reselect';

export const passwordExpiryNotificationVisibleSelector = createSelector(
    state => state.passwordExpiry,
    (passwordExpiry): ?boolean => {
        return passwordExpiry.getIn(['isNotificationVisible']);
    }
);
